import * as Types from './actionTypes';
import { ORDER_TYPES } from './constants';

export const initCategories = categories => ({
  type: Types.INIT_CATEGORIES,
  payload: {
    categories,
  },
});

export const initShippers = shippers => ({
  type: Types.INIT_SHIPPERS,
  payload: {
    shippers,
  },
});

export const search = values => ({
  type: Types.SEARCH,
  payload: {
    values,
  },
});

export const cancel = shipmentId => ({
  type: Types.CANCEL,
  payload: {
    shipmentId,
  },
});

export const preBookPrepare = (
  url,
  shipmentId,
  itineraryId,
  shipperId,
  paymentInfo,
  auditInfo = {},
) => ({
  type: Types.PREPARE_PRE_BOOK,
  payload: {
    url,
    shipmentId,
    itineraryId,
    shipperId,
    paymentInfo,
    auditInfo,
  },
});

export const destroyPreBook = () => ({
  type: Types.DESTROY_PRE_BOOK,
});

export const setBookingStep = step => ({
  type: Types.SET_BOOKING_STEP,
  payload: {
    step,
  },
});

export const preBook = (quote, payment, orderType = ORDER_TYPES.ORDER) => ({
  type: Types.PRE_BOOK,
  payload: {
    quote,
    payment,
    orderType,
  },
});
